module.exports = __webpack_public_path__ + "img/仪器设备.6208bac0.svg";